"use strict";

import $ from "jquery";
import Swiper from "swiper";

export default class TestimonialsCarousel {
  constructor($el) {
    this.$el = $($el);
    this.$slide = this.$el.find(".swiper-slide");
    this.$pagination = this.$el.find(".swiper-pagination");

    $(document).ready(() => {
      this.setup();
    });
  }

  combinedOpts(...opts) {
    return $.extend(...opts);
  }

  createOpts() {
    this.defaultOpts = {
      a11y: true,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      loop: true,
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      pagination: {
        clickable: true,
        el: this.$el.find(".swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) =>
          '<span class="' + className + '">' + "</span>",
      },
      spaceBetween: 0,
      speed: 400,
    };
    this.singleOpts = {
      a11y: true,
      allowTouchMove: false,
      autoplay: false,
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
    };
    this.userOpts = this.$el.data("opts") || {};
  }
  //Just in case
  // destroy(){
  //   this.swiperInstance.destroy(true)
  //   this.swiperInstance =  null
  //   $(window).unbind('resize.swiper')
  // }
  setup() {
    this.createOpts();
    if (this.$slide.length > 1) {
      let opts = this.combinedOpts(this.defaultOpts, this.userOpts);
      this.currentOpts = opts;
      this.swiperInstance = new Swiper(
        this.$el.find(".swiper-container"),
        opts,
      );
    } else {
      let opts = this.combinedOpts(this.singleOpts, this.userOpts);
      this.currentOpts = opts;
      this.swiperInstance = new Swiper(
        this.$el.find(".swiper-container"),
        opts,
      );
    }
  }
}
